import { ProgramLabel } from '@type/buzzkuri/programs'
import React from 'react'
import { RecommendTagListItem } from './Item'

type Props = {
  recommendTags: ProgramLabel[]
}

export const RecommendTagList = ({ recommendTags }: Props): JSX.Element => {
  return (
    <div className="flex flex-row flex-wrap justify-center items-center px-[1.2vw] pt-[2.5vw] mt:pt-[2.2vw] lg:pb-[1vw] w-[87.2vw] lg:w-[62.6vw] rounded-[10px] lg:rounded-[20px] shadow-toppage">
      {recommendTags.map((item, i) => (
        <RecommendTagListItem key={i} {...item} />
      ))}
    </div>
  )
}
